import React, { useEffect, useRef, useState } from "react";
import { FaArrowLeft } from "react-icons/fa6";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "./partial/Header";
import Sidebar from "./partial/Sidebar";
import JoditEditor from "jodit-react";
import toast, { Toaster } from "react-hot-toast";
import ChangePassword from "./partial/ChangePassword";
import { packageImgUrl, ImgUrl } from "../Constant";
import {
 
  useReferencePackageBySlugQuery,
  useUpdateReferencePackageMutation,
  
} from "../../redux/API/ReferenceApi";
import { useAllDestinationQuery } from "../../redux/API/DestinationApi";

const UpdateRelatedPackage = () => {
  const [newClass, setNewClass] = useState("");
  const [newSidebarClass, setNewSidebarClass] = useState("");
  const [showPass, setShowPass] = useState(false);
  const { slug } = useParams();
  const {data, refetch} = useReferencePackageBySlugQuery(slug)
  console.log("Print the data here ",data)
  const {data:destiantionData} = useAllDestinationQuery();
  console.log("Print the destinationData ",destiantionData)

  const overviewEditor = useRef(null);
  const itineraryEditor = useRef(null);
  const otherInformationEditior = useRef(null);

  const { name, price, overview, itinerary, otherInfo, destinationId } =
    data?.relatedPackages    || {
      name: "",
      price: "",
      updateOverview: "",
      updateItinerary: "",
      updateOtherInfo: "",
      destinationId: "",
    };
  console.log("Printing the relatedPackages ",data?.relatedPackages)

  const [image, setUpdateImage] = useState("");
  const [updateName, setUpdateName] = useState("");
  const [updatePrice, setUpdatePrice] = useState("");
  const [updateOverview, setUpdateOverview] = useState("");
  const [updateItinerary, setUpdateItinerary] = useState("");
  const [updateOtherInfo, setUpdateOtherInfo] = useState("");
  const [updateDestinationId, setUpdateDestinationId] = useState("");
  const fileInputRef = useRef(null);

  const [showError, setShowError] = useState({
    name: false,
    price: false,
    updateOverview: false,
  });

  const navigate = useNavigate();
  
  useEffect(() => {
    if (data?.package) {
      const packageData = data.package;
      
      setUpdateName(packageData.name);
      setUpdatePrice(packageData.price);
      setUpdateOverview(packageData.overview);
      setUpdateItinerary(packageData.itinerary);
      setUpdateOtherInfo(packageData.otherInfo);
      setUpdateDestinationId(packageData.destinationId?._id); // Access nested _id
    }
    refetch();
  }, [data, refetch]);

  const [postData] = useUpdateReferencePackageMutation();

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
  
    const sizeLimit = 2 * 1024 * 1024;
    const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
    const allowedExtensions = ['jpg', 'jpeg', 'png', 'webp'];
  
    const ext = file.name.split('.').pop().toLowerCase();
    const isValidType = allowedTypes.includes(file.type);
    const isValidExtension = allowedExtensions.includes(ext);
  
    const resetInput = () => {
      setUpdateImage(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
        e.target.type = '';
        e.target.type = 'file';
      }
    };
  
    if (!isValidType || !isValidExtension) {
      toast.error("Invalid file format. Only JPG, JPEG, PNG, WEBP are allowed.");
      resetInput();
      return;
    }
  
    if (file.size > sizeLimit) {
      toast.error("File size should be less than 2MB");
      resetInput();
      return;
    }
  
    const objectUrl = URL.createObjectURL(file);
    const img = new Image();
    img.src = objectUrl;
  
    img.onload = () => {
      if (img.width === 1500 && img.height === 400) {
        setUpdateImage(file);
      } else {
        toast.error("Image dimensions should be 1500x400");
        resetInput();
      }
      URL.revokeObjectURL(objectUrl);
    };
  
    img.onerror = () => {
      toast.error("Invalid image file.");
      resetInput();
      URL.revokeObjectURL(objectUrl);
    };
  };
  
  const handleUpdatePackage = (e) => {
    e.preventDefault();
  
    const checkField = {
      name: updateName === "",
      price: updatePrice === "",
      overview: updateOverview === "",
    };
  
    setShowError(checkField);
    const hasError = Object.values(checkField).some((error) => error);
    if (hasError) return;
  
    const formData = new FormData();
    formData.append("name", updateName);
    formData.append("destinationId", updateDestinationId);
    formData.append("price", updatePrice);
    formData.append("overview", updateOverview);
    formData.append("itinerary", updateItinerary);
    formData.append("otherInfo", updateOtherInfo);
    formData.append("image", image);
    formData.append("slug", slug);
  
    postData({ slug: slug, data: formData })
      .then((res) => {
        if (res?.data?.success) {
          navigate("/admin/relatedpack");
        } else {
          // Display backend error message
          toast.error(res?.error?.data?.message || "Something went wrong, Please try later.");
        }
      })
      .catch((err) => {
        // Display backend error message if available
        const errorMessage =
          err?.response?.data?.message || err?.message || "Something went wrong, Please try later.";
        toast.error(errorMessage);
      });
  };
  
  const handleToggle = () => {
    setNewClass((prev) => (prev === "" ? "main-active" : ""));
    setNewSidebarClass((prev) => (prev === "" ? "closed" : ""));
  };

  return (
    <>
      <Toaster position="top-right" />
      <Sidebar newSidebarClass={newSidebarClass} setShowPass={setShowPass} />
      <div className={`main-context ${newClass}`}>
        <Header handleToggle={handleToggle} />
        <div className="admin-dashboard p-4">
          <div aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item active" aria-current="page">
                Update Package
              </li>
            </ol>
          </div>
          <div className="d-flex justify-content-end pe-2 mb-3">
            <Link to="/admin/relatedpack" className="btn btn-primary rounded-2">
              Back <FaArrowLeft />
            </Link>
          </div>
          <div className="container card p-4">
            <form className="row gy-3" onSubmit={handleUpdatePackage}>
              <div className="col-lg-6">
                <label htmlFor="name">
                  Package Name <sup className="text-danger fs-6">*</sup>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  placeholder="Enter Package Name"
                  value={updateName}
                  onChange={(e) => setUpdateName(e.target.value)}
                />
                {showError.name && (
                  <p className="text-danger mt-1 mb-0">
                    Please Provide Package Name
                  </p>
                )}
              </div>

              <div className="col-lg-6">
              <label htmlFor="destinationId">Destination</label>
              <select
                className="form-control"
                id="destinationId"
                name="destinationId"
                value={updateDestinationId}
                onChange={(e) => setUpdateDestinationId(e.target.value)}
              >
                <option value="">Select Destination</option>
                {destiantionData?.destinations?.map((dest) => (
                  <option key={dest?._id} value={dest?._id} selected={dest?._id === updateDestinationId} >
                    {dest?.name}
                  </option>
                ))}
              </select>
              </div>


              <div className="col-lg-6">
                <label htmlFor="price">
                  Price <sup className="text-danger fs-6">*</sup>
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="price"
                  name="price"
                  placeholder="Enter Price"
                  value={updatePrice}
                  onChange={(e) => setUpdatePrice(e.target.value)}
                />
                {showError.price && (
                  <p className="text-danger mt-1 mb-0">Please Provide Price</p>
                )}
              </div>

              <div className="col-lg-6">
                <label htmlFor="image">Image</label>
                <input
                  type="file"
                  className="form-control"
                  id="image"
                  name="image"
                  onChange={handleImageChange}
                  ref={fileInputRef}
                />
              </div>

              <div className="col-lg-6">
                <label htmlFor="overview">
                  Overview <sup className="text-danger fs-6">*</sup>
                </label>
                <JoditEditor
                  ref={overviewEditor}
                  value={updateOverview }
                  onChange={(newContent) => setUpdateOverview(newContent)}
                />
                {showError.overview && (
                  <p className="text-danger mt-1 mb-0">
                    Please Provide Overview
                  </p>
                )}
              </div>

              <div className="col-lg-6">
                <label htmlFor="itinerary">Itinerary</label>
                <JoditEditor
                  ref={itineraryEditor}
                  value={updateItinerary}
                  onChange={(newContent) =>
                    setUpdateItinerary(newContent)
                  }
                />
              </div>

              <div className="col-lg-6">
                <label htmlFor="otherInfo">Other Information</label>
                <JoditEditor
                  ref={otherInformationEditior}
                  value={updateOtherInfo}
                  onChange={(newContent) =>
                    setUpdateOtherInfo(newContent)
                  }
                />
              </div>
                
                <div className="col-lg-12 pt-4">
                <button
                  className="btn btn-primary px-4 rounded-2"
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {showPass && <ChangePassword setShowPass={setShowPass} />}
    </>
  );
};

export default UpdateRelatedPackage;
